import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { useSelector, useDispatch } from "react-redux";
import {
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Link,
} from "@mui/material";
import Toolbar from "@mui/material/Toolbar";
import { User, Home, FileText } from "react-feather";
import { headerActions } from "../../store/header";
import { notificationActions } from "../../store/notification";
import { getUrl } from "aws-amplify/storage";

import "./index.css";

export default function Sidebar(props) {
  const history = useHistory();
  const dispatch = useDispatch();
  const isUserLoggedIn = useSelector((state) => state.auth.loggedIn);
  const user = useSelector((state) => state.auth.user);
  const [activeItem, setActiveItem] = useState("");
  const [fileUrl, setFileUrl] = useState("");

  useEffect(() => {
    async function fetchFileUrl() {
      const url = await getUrl({
        path: `public/documents/Fiduciary-accountantsGPS_Privacy-Policy-Statement_April-2023.pdf`,
        options: {
          validateObjectExistence: true,
        },
      });

      if (url && url.url && url.url.href) {
        setFileUrl(url.url.href);
      }
    }
    fetchFileUrl();
  }, []);

  const selectListItem = (listItemName) => {
    async function setData() {
      setActiveItem(listItemName);
      dispatch(headerActions.setSelectedMenu(listItemName));
    }
    setData();
  };

  const togglePanel = (panel, state) => {
    dispatch(
      headerActions.handlePanelState({
        profileMenu: false,
        shopping: false,
        [panel]: state,
      })
    );
  };

  const handleSelect = (item) => {
    switch (item) {
      case "Profile":
        togglePanel("profileMenu", true);
        break;
      case "Library":
        history.push("/library");
        break;
      default:
    }
  };

  const scrollWithOffset = (el) => {
    const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
    const yOffset = -80;
    window.scrollTo({ top: yCoordinate + yOffset, behavior: "smooth" });
  };

  return (
    <>
      <Drawer
        className={"drawer"}
        variant="permanent"
        classes={{
          paper: "drawerPaper",
        }}
        anchor="left"
      >
        <Toolbar style={{ marginBottom: 24 }} />
        <List>
          <ListItem
            disableRipple
            className={"listItem"}
            button
            selected={activeItem === "Home"}
            onClick={() => {
              selectListItem("Home");
            }}
            key="Home"
            classes={{ selected: "listItemSelected" }}
            component={HashLink}
            to="/#"
            scroll={(el) => el.scrollIntoView({ behavior: "smooth" })}
          >
            <ListItemIcon className={"listItemIcon"}>
              <Home />
            </ListItemIcon>
            <ListItemText
              classes={{
                primary: "text14",
              }}
              primary="Home"
            />
          </ListItem>
          <ListItem
            disableRipple
            className={"listItem"}
            button
            selected={activeItem === "Profile"}
            onClick={() => {
              selectListItem("Profile");
              handleSelect("Profile");
            }}
            key="Account Settings"
            classes={{ selected: "listItemSelected" }}
            disabled={!isUserLoggedIn}
          >
            <ListItemIcon className={"listItemIcon"}>
              <User />
            </ListItemIcon>
            <ListItemText
              classes={{
                primary: "text14",
              }}
              primary="Account Settings"
            />
          </ListItem>

          <ListItem className={"itemBetween"} />
          <ListItem className={`listItem listItemModifier`}>
            <ListItemText
              primary="PRODUCTS"
              className={"listItemIcon"}
              classes={{
                primary: "text11Mofifier",
              }}
            />
          </ListItem>
          <ListItem
            disableRipple
            className={"listItem"}
            button
            selected={activeItem === "Reports"}
            onClick={() => {
              selectListItem("Reports");
            }}
            key="Reports"
            classes={{ selected: "listItemSelected" }}
            component={HashLink}
            smooth
            to="/#anchor-report"
            scroll={(el) => scrollWithOffset(el)}
          >
            <ListItemIcon className={"listItemIcon"}>
              <FileText />
            </ListItemIcon>
            <ListItemText
              classes={{
                primary: "text14",
              }}
              primary="Reports"
            />
          </ListItem>
        </List>
        <Link
          href="#"
          underline="none"
          style={{ position: "absolute", bottom: "38px" }}
          className={`link text11`}
          onClick={() => {
            history.push("/contact");
            dispatch(
              notificationActions.setMessageReportedInContact({
                messageReportedInContact: "",
              })
            );
            dispatch(
              notificationActions.setIsMessageReported({
                isMessageReported: false,
              })
            );
          }}
        >
          {"Contact Us"}
        </Link>
        <Link
          href={fileUrl}
          underline="none"
          style={{ position: "absolute", bottom: "16px" }}
          className={`link text11`}
          rel="noopener noreferrer"
          target="_blank"
        >
          {"Privacy"}
        </Link>
      </Drawer>
    </>
  );
}
